import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=dfbdf616&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbdf616",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfbdf616')) {
      api.createRecord('dfbdf616', component.options)
    } else {
      api.reload('dfbdf616', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=dfbdf616&scoped=true&", function () {
      api.rerender('dfbdf616', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Y9MEoLy97bMv/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports